import { Error as ErrorIcon, Circle } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FgaUserState } from '@/generated/model';

import type { UserAccessState } from '../../types/UserAccessState';
import { getStateLabelKey } from '../../utils/userStateUtils';

type StatusIconConfig = {
  Icon: typeof Circle;
  color: 'success' | 'error' | 'warning';
};

const statusIconConfig = {
  [FgaUserState.ACTIVE]: { Icon: Circle, color: 'success' },
  [FgaUserState.DEACTIVATED]: { Icon: Circle, color: 'error' },
  [FgaUserState.WAITING_FOR_ACTIVATION]: { Icon: ErrorIcon, color: 'warning' },
} satisfies Record<UserAccessState, StatusIconConfig>;

export function UserStatusIcon({ state }: { state: UserAccessState }) {
  const { t } = useTranslation();
  const label = t(getStateLabelKey(state));
  const { Icon, color } = statusIconConfig[state];

  return (
    <Tooltip title={label}>
      <Box component="span" role="img" aria-label={label} display="inline-flex">
        <Icon color={color} sx={{ fontSize: 20 }} aria-hidden="true" />
      </Box>
    </Tooltip>
  );
}
